
// GET PROFILE
export const getProfileReducer = (state = {}, action) => {
    switch (action.type) {
        case "GET_PROFILE_REQUEST":
            return {
                ...state,
                loading: true,
            };
        case "GET_PROFILE_SUCCESS":
            return {
                ...state,
                loading: false,
                getUserDetails: action.payload,
            };
        case "GET_PROFILE_FAILED":
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        case "GET_PROFILE_RESET":
            return {
                ...state,
                loading: false,
                error: null,
                getUserDetails: null,
            };
        default:
            return state;
    }
}

// EDIT PROFILE
export const editProfileReducer = (state = {}, action) => {
    switch (action.type) {
        case "EDIT_PROFILE_REQUEST":
            return {
                ...state,
                loading: true,
            };
        case "EDIT_PROFILE_SUCCESS":
            return {
                ...state,
                loading: false,
                getUserInfo: action.payload,
            };
        case "EDIT_PROFILE_FAILED":
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        case "EDIT_PROFILE_RESET":
            return {
                ...state,
                loading: false,
                error: null,
                getUserInfo: null,
            };
        default:
            return state;
    }
}

// EDIT PROFILE
export const changePasswordReducer = (state = {}, action) => {
    switch (action.type) {
        case "CHANGE_PASSWORD_REQUEST":
            return {
                ...state,
                loading: true,
            };
        case "CHANGE_PASSWORD_SUCCESS":
            return {
                ...state,
                loading: false,
                changePasswordResponse: action.payload,
            };
        case "CHANGE_PASSWORD_FAILED":
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        case "CHANGE_PASSWORD_RESET":
            return {
                ...state,
                loading: false,
                error: null,
                changePasswordResponse: null,
            };
        default:
            return state;
    }
}

// DASHBOARD
export const dashboardGetReducer = (state = {}, action) => {
    switch (action.type) {
        case "DASHBOARD_GET_REQUEST":
            return {
                ...state,
                loading: true,
            };
        case "DASHBOARD_GET_SUCCESS":
            return {
                ...state,
                loading: false,
                dashGetData: action.payload,
            };
        case "DASHBOARD_GET_FAILED":
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        default:
            return state;
    }
}

// ALL TENDER COMPANIES GET
export const getAllTendersCompaniesReducer = (state = {}, action) => {
    switch (action.type) {
        case "GET_ALL_TENDERS_COMPANIES_REQUEST":
            return {
                ...state,
                loading: true,
            };
        case "GET_ALL_TENDERS_COMPANIES_SUCCESS":
            return {
                ...state,
                loading: false,
                allTendersCompaniesData: action.payload,
            };
        case "GET_ALL_TENDERS_COMPANIES_FAILED":
            return {
                ...state,
                loading: false,
                allTendersCompaniesData: null,
                error: action.payload,
            };
        case "GET_ALL_TENDERS_COMPANIES_RESET":
            return {
                ...state,
                allTendersCompaniesData: null,
                error: null
            };
        default:
            return state;
    }
}

// INTERESTED COMPANIES
export const getIntrestedTenderCompaniesReducer = (state = {}, action) => {
    switch (action.type) {
        case "GET_INTERESTED_TENDERS_COMPANIES_REQUEST":
            return {
                ...state,
                loading: true,
            };
        case "GET_INTERESTED_TENDERS_COMPANIES_SUCCESS":
            return {
                ...state,
                loading: false,
                tendersCompaniesData: action.payload,
            };
        case "GET_INTERESTED_TENDERS_COMPANIES_FAILED":
            return {
                ...state,
                loading: false,
                tendersCompaniesData: null,
                error: action.payload,
            };
        case "GET_INTERESTED_TENDERS_COMPANIES_RESET":
            return {
                ...state,
                tendersCompaniesData: null,
                error: null
            };
        default:
            return state;
    }
}

export const getIntrestedTenderCompaniesDropdownReducer = (state = {}, action) => {
    switch (action.type) {
        case "GET_INTERESTED_TENDERS_COMPANIES_DROPDOWN_REQUEST":
            return {
                ...state,
                loading: true,
            };
        case "GET_INTERESTED_TENDERS_COMPANIES_DROPDOWN_SUCCESS":
            return {
                ...state,
                loading: false,
                tendersCompaniesDropdownData: action.payload,
            };
        case "GET_INTERESTED_TENDERS_COMPANIES_DROPDOWN_FAILED":
            return {
                ...state,
                loading: false,
                tendersCompaniesDropdownData: null,
                error: action.payload,
            };
        case "GET_INTERESTED_TENDERS_COMPANIES_DROPDOWN_RESET":
            return {
                ...state,
                tendersCompaniesDropdownData: null,
                error: null
            };
        default:
            return state;
    }
}

// ALL TENDERS GET
export const getAllTendersReducer = (state = {}, action) => {
    switch (action.type) {
        case "GET_ALL_TENDERS_REQUEST":
            return {
                ...state,
                loading: true,
            };
        case "GET_ALL_TENDERS_SUCCESS":
            return {
                ...state,
                loading: false,
                allTendersData: action.payload,
            };
        case "GET_ALL_TENDERS_FAILED":
            return {
                ...state,
                loading: false,
                allTendersData: null,
                error: action.payload,
            };
        case "GET_ALL_TENDERS_RESET":
            return {
                ...state,
                allTendersData: null,
                error: null
            };
        default:
            return state;
    }
}

// USER INTERESTED COMPANIES
export const userCompaniesFilterReducer = (state = {}, action) => {
    switch (action.type) {
        case "SAVE_USER_INTERESTED_COMPANIES_REQUEST":
            return {
                ...state,
                loading: true,
            };
        case "SAVE_USER_INTERESTED_COMPANIES_SUCCESS":
            return {
                ...state,
                loading: false,
                interestedCompaniesData: action.payload,
            };
        case "SAVE_USER_INTERESTED_COMPANIES_FAILED":
            return {
                ...state,
                loading: false,
                interestedCompaniesData: null,
                error: action.payload,
            };
        case "SAVE_USER_INTERESTED_COMPANIES_RESET":
            return {
                ...state,
                loading: false,
                interestedCompaniesData: null,
                error: null
            };
        default:
            return state;
    }
}

// GET TENDERS GET DEPARTMENTS
export const getDepartmentsReducer = (state = {}, action) => {
    switch (action.type) {
        case "GET_DEPARTMENTS_REQUEST":
            return {
                ...state,
                loading: true,
            };
        case "GET_DEPARTMENTS_SUCCESS":
            return {
                ...state,
                loading: false,
                getDepartmentsData: action.payload,
            };
        case "GET_DEPARTMENTS_FAILED":
            return {
                ...state,
                loading: false,
                getDepartmentsData: null,
                error: action.payload,
            };
        case "GET_DEPARTMENTS_RESET":
            return {
                ...state,
                getDepartmentsData: null,
                error: null
            };
        default:
            return state;
    }
}

// GET TENDERS ADD DEPARTMENTS
export const addDepartmentReducer = (state = {}, action) => {
    switch (action.type) {
        case "ADD_DEPARTMENT_REQUEST":
            return {
                ...state,
                loading: true,
            };
        case "ADD_DEPARTMENT_SUCCESS":
            return {
                ...state,
                loading: false,
                addDepartmentData: action.payload,
            };
        case "ADD_DEPARTMENT_FAILED":
            return {
                ...state,
                loading: false,
                addDepartmentData: null,
                error: action.payload,
            };
        case "ADD_DEPARTMENT_RESET":
            return {
                ...state,
                addDepartmentData: null,
                error: null
            };
        default:
            return state;
    }
}

// GET TENDERS SELECT DEPARTMENTS
export const selectDepartmentReducer = (state = {}, action) => {
    switch (action.type) {
        case "SELECT_DEPARTMENT_REQUEST":
            return {
                ...state,
                loading: true,
            };
        case "SELECT_DEPARTMENT_SUCCESS":
            return {
                ...state,
                loading: false,
                selectDepartmentData: action.payload,
            };
        case "SELECT_DEPARTMENT_FAILED":
            return {
                ...state,
                loading: false,
                selectDepartmentData: null,
                error: action.payload,
            };
        case "SELECT_DEPARTMENT_RESET":
            return {
                ...state,
                selectDepartmentData: null,
                error: null
            };
        default:
            return state;
    }
}

// SELECTED TOTAL DEPARTMENTAL
export const selectedTotalDepartmentsReducer = (state = {}, action) => {
    switch (action.type) {
        case "SELECTED_TOTAL_DEPARTMENT_REQUEST":
            return {
                ...state,
                loading: true,
            };
        case "SELECTED_TOTAL_DEPARTMENT_SUCCESS":
            return {
                ...state,
                loading: false,
                getTotalDepartments: action.payload,
            };
        case "SELECTED_TOTAL_DEPARTMENT_FAILED":
            return {
                ...state,
                loading: false,
                getTotalDepartments: null,
                error: action.payload,
            };
        case "SELECTED_TOTAL_DEPARTMENT_RESET":
            return {
                ...state,
                getTotalDepartments: null,
                error: null
            };
        default:
            return state;
    }
}

// ALL ASSIGNED TENDERS 
export const getAssignedTendersReducer = (state = {}, action) => {
    switch (action.type) {
        case "GET_ALL_ASSIGNED_TENDERS_REQUEST":
            return {
                ...state,
                loading: true,
            };
        case "GET_ALL_ASSIGNED_TENDERS_SUCCESS":
            return {
                ...state,
                loading: false,
                assignedTenderData: action.payload,
            };
        case "GET_ALL_ASSIGNED_TENDERS_FAILED":
            return {
                ...state,
                loading: false,
                assignedTenderData: null,
                error: action.payload,
            };
        case "GET_ALL_ASSIGNED_TENDERS_RESET":
            return {
                ...state,
                assignedTenderData: null,
                error: null
            };
        default:
            return state;
    }
}

// ASSIGNED TENDERS SELECT
export const assignedTenderStatusReducer = (state = {}, action) => {
    switch (action.type) {
        case "ASSIGNED_TENDER_STATUS_REQUEST":
            return {
                ...state,
                loading: true,
            };
        case "ASSIGNED_TENDER_STATUS_SUCCESS":
            return {
                ...state,
                loading: false,
                assignedTenderSelectData: action.payload,
            };
        case "ASSIGNED_TENDER_STATUS_FAILED":
            return {
                ...state,
                loading: false,
                assignedTenderSelectData: null,
                error: action.payload,
            };
        case "ASSIGNED_TENDER_STATUS_RESET":
            return {
                ...state,
                assignedTenderSelectData: null,
                error: null
            };
        default:
            return state;
    }
}

// ASSIGNED TENDERS SELECT
export const changeDepartmentApiReducer = (state = {}, action) => {
    switch (action.type) {
        case "CHANGE_DEPARTMENT_REQUEST":
            return {
                ...state,
                loading: true,
            };
        case "CHANGE_DEPARTMENT_SUCCESS":
            return {
                ...state,
                loading: false,
                changeDepartmentData: action.payload,
            };
        case "CHANGE_DEPARTMENT_FAILED":
            return {
                ...state,
                loading: false,
                changeDepartmentData: null,
                error: action.payload,
            };
        case "CHANGE_DEPARTMENT_RESET":
            return {
                ...state,
                changeDepartmentData: null,
                error: null
            };
        default:
            return state;
    }
}

// ASSIGNED TENDERS SELECT
export const deleteTenderApiReducer = (state = {}, action) => {
    switch (action.type) {
        case "DELETE_TENDER_REQUEST":
            return {
                ...state,
                loading: true,
            };
        case "DELETE_TENDER_SUCCESS":
            return {
                ...state,
                loading: false,
                deleteTenderData: action.payload,
            };
        case "DELETE_TENDER_FAILED":
            return {
                ...state,
                loading: false,
                deleteTenderData: null,
                error: action.payload,
            };
        case "DELETE_TENDER_RESET":
            return {
                ...state,
                deleteTenderData: null,
                error: null
            };
        default:
            return state;
    }
}

// INTERESTED TENDERS GET 
export const getInterestedTendersReducer = (state = {}, action) => {
    switch (action.type) {
        case "INTERESTED_TENDERS_GET_REQUEST":
            return {
                ...state,
                loading: true,
            };
        case "INTERESTED_TENDERS_GET_SUCCESS":
            return {
                ...state,
                loading: false,
                interestedTendersData: action.payload,
            };
        case "INTERESTED_TENDERS_GET_FAILED":
            return {
                ...state,
                loading: false,
                interestedTendersData: null,
                error: action.payload,
            };
        case "INTERESTED_TENDERS_GET_RESET":
            return {
                ...state,
                interestedTendersData: null,
                error: null
            };
        default:
            return state;
    }
}

// INTERESTED TENDERS DOCUMENT
export const interestedTenderDocumentsReducer = (state = {}, action) => {
    switch (action.type) {
        case "INTERESTED_TENDER_DOCUMENTS_REQUEST":
            return {
                ...state,
                loading: true,
            };
        case "INTERESTED_TENDER_DOCUMENTS_SUCCESS":
            return {
                ...state,
                loading: false,
                interestedTenderDocumentData: action.payload,
            };
        case "INTERESTED_TENDER_DOCUMENTS_FAILED":
            return {
                ...state,
                loading: false,
                interestedTenderDocumentData: null,
                error: action.payload,
            };
        case "INTERESTED_TENDER_DOCUMENTS_RESET":
            return {
                ...state,
                interestedTenderDocumentData: null,
                error: null
            };
        default:
            return state;
    }
}

// APPLIED TENDERS GET
export const getAppliedTendersReducer = (state = {}, action) => {
    switch (action.type) {
        case "GET_APPLIED_TENDERS_REQUEST":
            return {
                ...state,
                loading: true,
            };
        case "GET_APPLIED_TENDERS_SUCCESS":
            return {
                ...state,
                loading: false,
                getAppliedTendersData: action.payload,
            };
        case "GET_APPLIED_TENDERS_FAILED":
            return {
                ...state,
                loading: false,
                getAppliedTendersData: null,
                error: action.payload,
            };
        case "GET_APPLIED_TENDERS_RESET":
            return {
                ...state,
                getAppliedTendersData: null,
                error: null
            };
        default:
            return state;
    }
}

// APPLIED TENDER DOCUMENT
export const appliedTenderDocumentReducer = (state = {}, action) => {
    switch (action.type) {
        case "APPLIED_TENDER_DOCUMENT_REQUEST":
            return {
                ...state,
                loading: true,
            };
        case "APPLIED_TENDER_DOCUMENT_SUCCESS":
            return {
                ...state,
                loading: false,
                saveTenderDocumentData: action.payload,
            };
        case "APPLIED_TENDER_DOCUMENT_FAILED":
            return {
                ...state,
                loading: false,
                saveTenderDocumentData: null,
                error: action.payload,
            };
        case "APPLIED_TENDER_DOCUMENT_RESET":
            return {
                ...state,
                saveTenderDocumentData: null,
                error: null
            };
        default:
            return state;
    }
}

// APPLY FOR TENDER
export const applyForTenderReducer = (state = {}, action) => {
    switch (action.type) {
        case "APPLY_FOR_TENDER_REQUEST":
            return {
                ...state,
                loading: true,
            };
        case "APPLY_FOR_TENDER_SUCCESS":
            return {
                ...state,
                loading: false,
                applyTenderData: action.payload,
            };
        case "APPLY_FOR_TENDER_FAILED":
            return {
                ...state,
                loading: false,
                applyTenderData: null,
                error: action.payload,
            };
        case "APPLY_FOR_TENDER_RESET":
            return {
                ...state,
                applyTenderData: null,
                error: null
            };
        default:
            return state;
    }
}

// TENDERS RESULTS GET
export const getTendersResultsReducer = (state = {}, action) => {
    switch (action.type) {
        case "GET_TENDERS_RESULTS_REQUEST":
            return {
                ...state,
                loading: true,
            };
        case "GET_TENDERS_RESULTS_SUCCESS":
            return {
                ...state,
                loading: false,
                getTendersResultsData: action.payload,
            };
        case "GET_TENDERS_RESULTS_FAILED":
            return {
                ...state,
                loading: false,
                getTendersResultsData: null,
                error: action.payload,
            };
        case "GET_TENDERS_RESULTS_RESET":
            return {
                ...state,
                getTendersResultsData: null,
                error: null
            };
        default:
            return state;
    }
}

// TENDERS RESULTS WIN
export const uploadTenderResultsReducer = (state = {}, action) => {
    switch (action.type) {
        case "UPLOAD_TENDER_RESULT_REQUEST":
            return {
                ...state,
                loading: true,
            };
        case "UPLOAD_TENDER_RESULT_SUCCESS":
            return {
                ...state,
                loading: false,
                tendersResultsUploadData: action.payload,
            };
        case "UPLOAD_TENDER_RESULT_FAILED":
            return {
                ...state,
                loading: false,
                tendersResultsUploadData: null,
                error: action.payload,
            };
        case "UPLOAD_TENDER_RESULT_RESET":
            return {
                ...state,
                tendersResultsUploadData: null,
                error: null
            };
        default:
            return state;
    }
}
